@use '../../../../../../../styles/Colors.scss' as Colors;
@use '../../../../../../../styles/Constants.scss' as Constants;

.side-panel-modal {
	padding: 0 !important;

	&__block-container-primary {
		display: flex;
		flex-direction: row;
		border-bottom: 1px solid Colors.$col-greyConnection;
		background-color: Colors.$col-blueBackground;
		border-left: 4px solid Colors.$col-darkBlueBorder;
		text-transform: uppercase;

		&--main {
			flex-direction: column;
		}
	}

	&__block-container-secondary {
		display: flex;
		flex-direction: row;
		border-bottom: 1px solid Colors.$col-greyConnection;
		gap: 0 2*Constants.$val-spacing-xxl;
		padding: Constants.$val-spacing-m;
		text-transform: uppercase;

		&--main {
			background-color: Colors.$col-greyLight;
			flex-direction: column;
		}
	}

	&__block {
		display: grid;
		grid-template-columns: repeat(12, 1fr);
		text-transform: none;

		&:has(.side-panel-modal__field--adjustable) {
			grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
		}

		&--repeating {
			display: flex;
			flex-direction: column;
			width: 100%;
		}

		padding: 0 Constants.$val-spacing-m;
		gap: Constants.$val-spacing-m;
		flex: 1;

		&--primary {
			border-left: 4px solid Colors.$col-darkBlueBorder;
			background-color: Colors.$col-blueBackground;
		}

		&--secondary {
			background-color: Colors.$col-white;
		}

		&--secondary-main {
			background-color: Colors.$col-greyLight;
		}

		&--job-ehs {
			padding-top: Constants.$val-spacing-m;
			padding-bottom: Constants.$val-spacing-m;
		}
		
		&__header-main {
			font-size: Constants.$val-fontSizeBig;
			padding: Constants.$val-spacing-m;
			color: Colors.$col-design-blue500;
			font-weight: bold;
			cursor: pointer;

			& > [class^="icon-"] {
				margin-left: Constants.$val-spacing-m;
				font-size: Constants.$val-fontSizeXBig;
			}
		}

		&__header-secondary {
			text-transform: uppercase;
			font-size: Constants.$val-fontSizeBig;
			font-weight: bold;
			display: flex;
			padding: 0 Constants.$val-spacing-m;
			align-items: center;
			justify-content: flex-start;
			height: 100%;
			cursor: pointer;

			& > [class^="icon-"] {
				margin-left: Constants.$val-spacing-m;
				font-size: Constants.$val-fontSizeXBig;
			}
		}

		&__title {
			padding: Constants.$val-spacing-l 0;
			white-space: nowrap;
		}
	}

	&__field {
		padding: Constants.$val-spacing-m 0;

		&--very-small {
			grid-column-end: span 1;
		}

		&--small {
			grid-column-end: span 2;
		}

		&--medium {
			grid-column-end: span 3;
		}

		&--large{
			grid-column-end: span 4;
		}

		&--largest {
			grid-column-end: span 12;
		}

		&--empty-line {
			grid-column-end: -1;
		}

		&--adjustable {
			gap: Constants.$val-spacing-s;
		}

		&--repeating {
			display: contents !important;
		}

		&__header {
			text-transform: none;
			font-weight: normal;
			margin-bottom: Constants.$val-spacing-s;
		}

		&__value {
			display: flex;
			flex-direction: column;
			font-weight: bold;

			& > img {
				width: 50px;
				height: 50px;
			}

			&--repeated {
				margin-bottom: Constants.$val-spacing-xs;

				& > img {
					width: 50px;
					height: 50px;
				}

				&:last-child {
					margin-bottom: 0;
				}
			}
		}

		&__image {
			cursor: pointer;
		}
	}

	&__descriptive-text {
		color: Colors.$col-red;
		white-space: pre-wrap;

		&--black-text {
			color: Colors.$col-black;
		}

		&--bold-text {
			font-weight: bold;
		}
	}

	&__calculated-field {
		text-transform: capitalize;
	}

	&__completed-field {
		display: flex;
		grid-column: span 12;
		justify-self: end;
		gap: Constants.$val-spacing-s;
		justify-content: center;
		padding: Constants.$val-spacing-l;
	}

	&__signature-field {
		display: flex;
		text-transform: none;
		grid-column: span 4;

		& > img {
			width: 72px;
			height: 72px;
		}
	}

	&__immutable-url {
		cursor: pointer;
		color: Colors.$col-blue;
		text-transform: none;
		
		&:hover {
			color: Colors.$col-blue !important;
		}
	}
}
